// import './vendors/jquery.svg.min.js';
// import './vendors/jquery.svganim.min.js';
import Panzoom from '@panzoom/panzoom';
//import LoadingOverlay from 'gasparesganga-jquery-loading-overlay';

class LotMap {

    /**
     * 
     * @param {*} elem jQuery element pointing to the `.lotmap` div container that will house the Lot Map and its controls
     */
    constructor(elem) {
        this.elem = $(elem);
        
        this.activeSection = "";      // active section in the lot map data
        this.jsonData = null;         // json data for this lot map
        this.nodeGuid = null;         // node guid of community of this lot map
        this.lotMap = null;
        this.SVG_BASE_URL = window.msh.siteUrl + "/api/lotmaps/v2/svg";  // Base URL for SVG requests
        this.JSON_BASE_URL = window.msh.siteUrl + "/api/lotmaps/v2/json";    // Base URL for JSON requests
        this.panzoomInstance = null;
    }

    /**
     * 
     * @param {*} nodeGuid 
     * @param {*} lotMap 
     */
    init() {

        this.lotMap = this.elem;
        this.nodeGuid = this.elem.find("#hfCommunitySitemapNodeGuid")

        // First check for existence of hidden field that marks a Community Lot Map existence
        if (this.lotMap.length == 0 || this.nodeGuid.length == 0) {
            throw new Error("Lot Map and/or its required data not found");
        }

        // Get the hidden field
        this.nodeGuid = this.elem.find("#hfCommunitySitemapNodeGuid").val();

        if (this.nodeGuid == null || this.nodeGuid.length < 1) {
            throw new Error("Lot Map missing required data");
        }

        $.ajaxSetup({
            async: true
        });
        
        // load the SVG
        this.loadSVG(null);
    }

    /**
     * Fetches the SVG and renders it 
     * @param {*} sectionId 
     */
    loadSVG(sectionId) {
        var _this = this;

        // Set the URL to retrieve SVG from for this community and section (if specified)
        var url = this.SVG_BASE_URL;
        if (this.nodeGuid != null && this.nodeGuid.length > 0) {
            url = url + "/" + this.nodeGuid;
        }

        if (sectionId != null && sectionId.length > 0) {
            url = url + "/" + sectionId;
        }

        // Fetch the SVG from lot map controller
        $.get(url, function (svg) {

            // if the SVG Url is not found, do not proceed and instead show error messaging
            if (svg !== 'SVG Url not found') {
                // Create the SVG html
                var div = document.createElement("div");

                // Display loading overlay over the lotmap container
                //_this.lotMap.LoadingOverlay("show");
                $(".show-for-sr").addClass('show');

                div.innerHTML = new XMLSerializer().serializeToString(svg.documentElement);

                document.body.insertBefore(div, document.body.childNodes[0]);
                _this.lotMap.find(".lotmap-svg-wrapper").empty();
                _this.lotMap.find(".lotmap-svg-wrapper").append(div);

                // init the div as a Panzoom element and specify the controls to pan/zoom it
                var panZoomControls = _this.lotMap.find(".lotmap-panzoom-controls");
                var elements = _this.lotMap.find(".lotmap-svg-wrapper.panzoom");
                
                for (let i = 0; i < elements.length; i++)
                {
                    elements[i].panzoom = Panzoom(elements[i]);
                    
                    $(panZoomControls.find(".lotmap-zoom-in")[0]).on("click", function(){
                        elements[i].panzoom.zoomIn();
                    });

                    $(panZoomControls.find(".lotmap-zoom-out")[0]).on("click", function(){
                        elements[i].panzoom.zoomOut();
                    });

                    $(panZoomControls.find(".lotmap-reset")[0]).on("click", function(){
                        elements[i].panzoom.reset();
                        elements[i].panzoom.pan(255, 0);
                    });

                    // Position the lot map so the left edge of the SVG graphic is not hidden by legend
                    setTimeout(function() {
                        elements[i].panzoom.pan(255, 0);
                    }, 250);
                };

                // Get the JSON data for this svg
                _this.loadDataAndColorSvg(sectionId);
                _this.lotMap.siblings(".lotmap-unavailable").hide();
                _this.lotMap.siblings(".sitemap_disclaimer, .lotmap-disclaimer").show();
            }
            else {
                // Show lot map error and hide any other lot map markup
                //_this.lotMap.LoadingOverlay("hide");
                _this.lotMap.siblings(".sitemap-disclaimer, .lotmap-disclaimer").hide();
                if ( _this.lotMap.siblings(".msh-buyer-tab_control").length) {
                    _this.lotMap.siblings(".msh-buyer-tab_control").hide();
                }
                _this.lotMap.siblings(".lotmap-unavailable").show();
                return;
            }
        });
    }

    /**
     * Retrieves the JSON data for this community and section in order to render SVG and color it base
     * on lot information
     * @param {*} sectionId 
     */
    loadDataAndColorSvg(sectionId) {
        var _this = this;

        // Set the URL to retrieve JSON data from for this community and section (if specified)
        var url = this.JSON_BASE_URL;
        if (this.nodeGuid != null && this.nodeGuid.length > 0) {
            url = url + "/" + this.nodeGuid;
        }

        if (sectionId != null && sectionId.length > 0) {
            url = url + "/" + sectionId;
        }

        // Fetch the SVG from lot map controller
        $.getJSON(url, function (json) {
            _this.jsonData = json;
            // If the JSON does not contain success status, return out and hide the lot map and show the error
            if (json.status !== "Success") {
                // Show lot map error and hide any other lot map markup
                _this.lotMap.find(".lotmap-unavailable").show();
                _this.lotMap.hide();
                _this.lotMap.find(".lotmap-disclaimer").hide();

                // Need to hide the spinning wheel that was opened during SVG load
                // Hide loading overlay over the lotmap container
                //_this.lotMap.LoadingOverlay("hide");
                $(".show-for-sr").removeClass('show');

                return;
            }

            // Determine the active section if active section is not set...if section link was clicked, it
            // should be set within the event handler for it
            if (_this.activeSection == null) {
                var activeSection = "";
                $.each(_this.jsonData.lot_map.sections.section, function () {
                    if (this.default === "true") {
                        activeSection = this.id;
                    }
                });
                _this.activeSection = activeSection;
            }


            /**
             * Color Lots
             */
            _this.buildSections();
            _this.colorLots();

            // Hide loading overlay over the lotmap container
            //_this.lotMap.LoadingOverlay("hide");
            _this.lotMap.find(".show-for-sr").removeClass('show');
        });
    }

    /**
     * 
     * @param {*} svg 
     * @param {*} error 
     */
    loadDone(svg, error) {
        var _this = this;
        if (error) {
            this._messageBoxContainer.html("<p>Error: Could not load lot map.<br /><br />Please try again.</p>")
        } else {
            _this._messageBoxContainer.html('<p>Loading lot details...<br /><br /><img src="/patternlibrary/dist/assets/ajax-loader.gif" /></p>');
            _this.buildSections();
            _this.colorLots();
        }
    }

    /**
     * 
     */
    buildSections() {
        var _this = this;
        var json_section = _this.jsonData.lot_map.sections.section;
        var section_output = "";
        var section_class = "none";
        if (json_section.length > 0) {
            $.each(json_section, function (index) {
                if (this.default === "true" && _this.activeSection == "") {
                    _this.activeSection = this.id;
                    section_class = "active";
                }
                else if (_this.activeSection == this.id) {
                    _this.activeSection = this.id;
                    section_class = "active";
                }
                else {
                    section_class = "";
                }

                // Construct the markup
                section_output += ' <a href="#" id="' + this.id + '" class="lotmap-section-link ' + section_class + '">' + this.display_name + "</a>";
                if (index != json_section.length - 1) {
                    section_output += "<br/>";
                }
            });
        }
        _this.lotMap.find(".lotmap-sections-placeholder").html(section_output);
        _this.lotMap.find(".lotmap-sections").show();

        // Assign click handlers to the section links
        var LOTMAP_SECTION_LINK_CLICK = "click.lotMapSectionLinkClick";
        _this.lotMap.find(".lotmap-section-link").off(LOTMAP_SECTION_LINK_CLICK).on(LOTMAP_SECTION_LINK_CLICK, function (e) {
            e.preventDefault();
            // Retrieve the SVG pointed to by the link
            var sectionId = $(this).attr("id");
            _this.activeSection = sectionId;
            _this.loadSVG(_this.activeSection);
        });
    }

    /**
     * Loop through lots and color them and tally total lots and number of available, unavailable, future, 
     * qmi, and "no-data" lots
     */
    colorLots() {
        var _this = this;
        _this.lotMap.find(".lotmap-msg-box").html('<p>Loading lot map...</p>');
        var json_lot = _this.jsonData.lot_map.lots.lot;
        var qmiNums = [];
        if (_this.jsonData.lot_map.qmi != null) {
            qmiNums = _this.jsonData.lot_map.qmi.map(function (x) {
                try {
                    return parseInt(x, 10)
                } catch (e) {
                    return x
                }
            });
        }

        var cntTotal = json_lot.length;
        var cntAvailable = 0;
        var cntUnavailable = 0;
        var cntFuture = 0;
        var cntNoData = 0;
        var cntQmi = 0;
        $.each(json_lot, function () {
            // only include lots that appear in the SVG elements
            var lotSvgElement = $("#lot-" + this.num);
            if (lotSvgElement != null) {
                if (qmiNums.indexOf(parseInt(this.num, 10)) >= 0) {
                    cntQmi++;
                    this.status_desc = "QMI"
                }
                if (this.status_desc == "Available") {
                    cntAvailable++
                }
                if (this.status_desc == "Closed" || this.status_desc == "Sold" || this.status_desc == "Hold" || this.status_desc == "Pending Sale" || this.status_desc == "No-Deposit Hold") {
                    cntUnavailable++
                }
                if (this.status_desc == "Future Release") {
                    cntFuture++
                }
                lotSvgElement.css({
                    fill: _this.dataToColor(this.status_desc),
                    transition: "2.0s"
                });
            }
        });
        cntNoData = cntTotal - cntAvailable - cntUnavailable - cntFuture - cntQmi;
        _this.lotMap.find(".lotmap-cnt-total").html("(" + cntTotal + ")");
        _this.lotMap.find(".lotmap-cnt-available").html("(" + cntAvailable + ")");
        _this.lotMap.find(".lotmap-cnt-unavailable").html("(" + cntUnavailable + ")");
        _this.lotMap.find(".lotmap-cnt-future").html("(" + cntFuture + ")");
        _this.lotMap.find(".lotmap-cnt-qmi").html("(" + cntQmi + ")");
        _this.lotMap.find(".lotmap-cnt-nodata").html("(" + cntNoData + ")");
        if (cntNoData < 1) {
            _this.lotMap.find(".lotmap-nodata-container").hide()
        }

        // Display the side sections
        _this.lotMap.find(".lotmap-legend").show();
        _this.lotMap.find(".lotmap-panzoom-controls").show();
    }

    /**
     * Given lot status, returns a color code for that lot
     * @param {string} lotStatus status of the lot which will determine its coloring
     * @returns Hexidecimal color code string of the color associated with the specified lot status. Returns "#fff" if status is not recognized
     */
    dataToColor(lotStatus) {
        switch (lotStatus) {
            case "Available":
                return "#AED438";
            case "Sold":
                return "#900";
            case "Hold":
                return "#900";
            case "No-Deposit Hold":
                return "#900";
            case "Closed":
                return "#900";
            case "Future Release":
                return "#0089AD";
            case "Pending Sale":
                return "#900";
            case "QMI":
                return "#F1FF0B";
            default:
                return "#fff"
        }
    }

    /**
     * 
     * @param {*} name 
     * @returns 
     */
    isSet(name) {
        return typeof this[name] !== "undefined"
    }
}

export default LotMap;
